export interface RealTimeReceivedPayload {
  layer_id: string
  steps: any[]
  client_uuids: string[]
  versions: number[]
  meta: { initial_sync?: boolean; client_uuid?: string; [key: string]: any }
  user: {
    id: number
    display_name: string
    avatar_url: string | null
  }
}

export const REAL_TIME_WS_CHANNEL = 'RealTimeChannel'
export const CONFIRM_LEAVE_MESSAGE = 'WARNING! Your changes are not saved. Are you sure you want to leave?'
export const UNCONFIRMED_STEP_COUNT_THRESHOLD = 50
export const UNCONFIRMED_STEP_RETRY_TIMEOUT_MS = 5000
export const UNCONFIRMED_STEP_STUCK_SYNC_MS = 10_000
export const THROTTLE_INTERVAL_MS = 400
export const ARTICLE_VIEW_UPDATE_INTERVAL = 30_000
export const LONG_DISCONNECT_TIME_MS = 10_000

export enum ConnectionStatus {
  Offline,
  Connecting,
  LongConnecting,
  Connected,
}

export enum StateSyncStatus {
  UpToDate,
  Saving,
  Behind,
}

export enum SyncStatus {
  InitialSync,
  Syncing,
  Synced,
}

export const SyncingStates = [SyncStatus.InitialSync, SyncStatus.Syncing]
